<template>
  <div class="dragContainer" :style="cardColor">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "DropZone",
  props: ["title", "height"],

  data() {
    return {
      isHovering: false,
      counter: 0,
    };
  },
  computed: {
    cardColor() {
      return {
        "background-color": this.isHovering ? "#EEEEEE" : "transparent",
      };
    },
  },

  mounted() {
    const self = this;
    window.addEventListener("dragenter", () => {
      self.isHovering = true;
      self.counter += 1;
      console.log("isHOvering->", self.isHovering);
    });

    window.addEventListener("dragleave", (e) => {
      e.preventDefault();

      self.counter -= 1;
      if (self.counter === 0) {
        self.isHovering = false;
        console.log("dragLeave->", self.isHovering);
      }
    });

    window.addEventListener("dragover", (e) => {
      e.preventDefault();
    });

    window.addEventListener("drop", (e) => {
      e.preventDefault();
      self.isHovering = false;
      const { files } = e.dataTransfer;
      console.log("Drop files:", files);
      self.$emit("file", Array.prototype.slice.call(files));
    });
  },
};
</script>
